import { Component, OnInit, ViewChild } from '@angular/core';

import { AppInformationService, ArkUnitOfWork, AuthService } from 'app/core/core.module';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AccountDetailComponent } from '../account-detail/account-detail.component';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';

@Component({
    selector: 'app-accounts',
    templateUrl: './accounts.component.html',
    styleUrls: ['./accounts.component.scss'],
    imports: [DevExtremeModule],
    standalone: true,
})
export class AccountsComponent implements OnInit {
    accounts: any[];
    canAdd = false;

    @ViewChild('accountsGrid') dataGrid: DxDataGridComponent;

    constructor(private uow: ArkUnitOfWork, private modalService: BsModalService, public appInfo: AppInformationService, private auth: AuthService) {}

    async ngOnInit() {
        await this.getData();
        this.canAdd = this.auth.hasRole('Accounts:Admin');
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const accounts = await this.uow.getAccounts(true);
        accounts.forEach((account: any) => {
            if (account.attachments.length > 0 && _.some(account.attachments, { deleted: null })) account.hasAttachment = true;
            else account.hasAttachment = false;
        });

        this.accounts = accounts;
        this.appInfo.pleaseWaitHide();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    rowPrepare(e) {
        if (e.rowType === 'data') {
            if (!e.data.active) {
                e.rowElement.className = e.rowElement.className + ' inactive-account';
            }
        }
    }

    rowDoubleClick(e) {
        // console.log(e);
        this.open(false, e.data.id);
    }

    open(add: boolean, accountId: number) {
        const modalRef = this.modalService.show(AccountDetailComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: { routerOption: add ? 'new' : 'edit', accountId: accountId },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.result) {
                await this.getData();
                // this.batches = await this.uow.getBatchList();
                // this.open(result.batchId);
                // this.dataGrid.instance.refresh();
            }
        });
    }
}
